import { ChevronRight } from '~/icons';
import { SocioIco } from '~/icons';
import { useState } from 'react'
import { SocioSwiftModal } from './SocioSwiftModal';

export function IsNotSocioBanner() {
  const [isOpenModal, setIsOpenModal] = useState(false)

  function handleOpenModal() {
    setIsOpenModal(true)
  }

  function handleCloseModal() {
    setIsOpenModal(false)
  }

  return (
    <>
      <SocioSwiftModal isOpen={isOpenModal} onClose={handleCloseModal} />

      <div
        className="p-4 rounded cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary-info focus:ring-offset-1 bg-primary-socio"

        onClick={() => handleOpenModal()}
        role="button"
        aria-label="Ir para a página de extrato de cashback"
        tabIndex={0}
        title='Ir para a página de extrato de cashback'
      >
        <div className="flex justify-between">
          <div>
            <p className="text-white text-sm" aria-hidden="true">
              Com o Sócio Swift,  você ganha
            </p>

            <p className="text-white text-sm font-sm" aria-hidden="true">
              <b className='font-medium'>  R$5,00 de cashback  </b>a cada
            </p>
          </div>
          <SocioIco aria-hidden="true" />
        </div>
        <div className="flex items-end justify-between">

          <div className='flex gap-1 justify-between items-center flex-1'>
            <p className="text-white text-sm" aria-hidden="true">
              R$100,00 em compras.
            </p>
            <ChevronRight className="fill-white text-lg mt-[1px]" aria-hidden="true" />
          </div>
        </div>
      </div>
    </>

  );
}
